import { ReactElement } from 'react'
import { AddComment } from '@mui/icons-material'
import { ToggleButton } from '@ui/actions'

interface Props {
  isAddCommentActive: boolean
  onToggleAddComment: () => void
}

/**
 * Toolbar button for the "Kommentar hinzufügen" tool. (Comments are now viewed/edited via the
 * permanent "Kommentare" tab in the element list, so the former "Kommentare anzeigen" mode toggle
 * was removed.)
 */
const CommentToolSelect = ({ isAddCommentActive, onToggleAddComment }: Props): ReactElement => (
  <ToggleButton
    hint="Kommentar hinzufügen (t)"
    tooltipPlacement="top"
    size="small"
    onClick={onToggleAddComment}
    selected={isAddCommentActive}
    Icon={AddComment}
    data-cy="btn-comment-select"
  />
)

export default CommentToolSelect
